<template>
    <div id="production" :class="[$mq, { 'collapsed': !sidebarExpanded, 'configuration': configuration }]">
        <div id="sidebar" :class="{ 'collapsed': !sidebarExpanded }" v-if="!configuration">
            <Sidebar :categories="categories" :date="date" :summary="summary" @selectDate="selectDate"
                @selectCategory="selectCategory" @toggle="toggleSidebar" :selected="!forecast"
                :reset="!configuration" :displayed="sidebarExpanded" :stock="stock" :expanded="!configuration" @selectMermaProduct="selectMermaProduct"></Sidebar>
        </div>

        <div id="board" :class="{ 'collapsed': !sidebarExpanded }">
            <div class="main-content">
                <Configuration v-if="configuration" :types="[6]" :plk="true" :fryers="fryers" :date="date" @updateForecast="updateForecast"/>
                <Init v-else-if="bSelectDate" :date="date"></Init>
                <ProductionView v-else ref="productionView" :products="products" :productsCooking="productsCooking" :fryers="fryers" :sidebarExpanded="sidebarExpanded" @addProduct="addProduct" @cookingCompleted="onCookingCompleted" @deleteSelected="deleteSelected" @divideProduct="divideProduct" :debug="debug"> </ProductionView>
            </div>
        </div>

        <div class="reset-notice" v-if="resetNotice">
            <div class="reset-notice-andy" aria-hidden="true"></div>
            <div class="reset-notice-body">
                <i class="i-andy-info-main i-andy-s" aria-hidden="true"></i>
                <span>{{ $t('production.plk.reset.notice') }}</span>
                <button type="button" class="reset-notice-close" :aria-label="$t('popup.default.text_cancel')" @click="dismissResetNotice">
                    <i class="i-andy-close i-andy-s" aria-hidden="true"></i>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
import Sidebar from '../components/domain/pls-stock/sidebar.vue'
import Topbar from '../components/domain/pls/topbar.vue'
import Configuration from '../components/domain/production/Configuration.vue'
import Init from '../components/domain/pls/init.vue'
import ProductionView from '../components/domain/pls-stock/productionView.vue'
import { filter } from 'lodash'
export default {
    components: {
        Sidebar,
        Configuration,
        Init,
        ProductionView,
        Topbar
    },
    name: 'PlsStock',
    data() {
        return {
            date: moment().format('YYYY-MM-DD'),
            isExpanded: false,
            firstLoad: true,
            loadInterval: null,
            userInteraction: false,
            refreshInterval: null,
            cookingCheckInterval: null, // Timer para verificar productos completados
            forecastUpdateInterval: null, // Timer para actualizar forecast cada minuto
            timeUpdateInterval: null, // Timer para recalcular tiempos cada minuto
            currentTimeInterval: null, // Timer para actualizar tiempo actual cada segundo
            sidebarExpanded: localStorage.getItem('sidebarExpanded') ? localStorage.getItem('sidebarExpanded') == 'true' : true,
            debug: false,
        }
    },
    computed: {
        pending_pc() {
            const self = this

            if (!self.nextAlarm) {
                return 0 // Return 0 if timer or nextAlarm is not available
            }

            const nextAlarm = moment(self.nextAlarm)

            const currentTimestampWithSeconds = moment().valueOf()
            const totalPendingTimeInSeconds = nextAlarm.diff(currentTimestampWithSeconds, 'seconds')
            const currentPendingTimeInSeconds = moment(currentTimestampWithSeconds).diff(currentTimestampWithSeconds, 'seconds')

            const elapsed = (currentPendingTimeInSeconds / totalPendingTimeInSeconds) * 100

            return parseInt(elapsed)
        },
        isSmallScreen() {
            return this.windowWidth < 1025
        },
        fryers(){
            const fryers = this.$store.getters['production/getFryers']
            if(!fryers) return [];
            /* if(fryers && fryers.length == 0){ //Si no hay fryers en el config, se crea uno por defecto
                const fryer = [{
                    id: 1,
                    status: 1
                }]
                
                this.$store.dispatch('production/toggleFryer', fryer).then(() => {
                    this.$store.commit('production/setFryers', fryer)
                })
                return fryer;
            } */
            return fryers
        },
        categories() {
            var types = [6]
            const allProducts = this.$store.getters['production/getProducts']
            var filteredProducts = filter(allProducts, (product) => types.includes(product.type))

            const categories = this.$store.getters['production/getCategories']
            const productsCategories = Object.values(filteredProducts).map((product) => product.category)
            return Object.values(categories).reduce((acc, category) => {
                if (productsCategories.includes(category.id)) {
                    acc[category.id] = category
                }
                return acc
            }, {})
        },
        category() {
            return this.$store.getters['production/getSelectedCategory']
        },
        forecast() {
            return this.$store.getters['production/getForecast']
        },
        bSelectDate() {
            return !this.forecast || Object.keys(this.forecast).length == 0 || !this.forecast.products || !this.forecast.products.pls
        },
        summary() {
            if(!this.forecast) return {}
            return this.forecast.summary
        },
        configuration() {
            return this.$store.getters['production/getConfiguration']
        },
        resetNotice() {
            return this.$store.getters['production/getResetNotice']
        },
        productsList(){
            const products = this.$store.getters['production/getProducts']
            return Object.entries(products).reduce((acc, [key, value]) => {
                if(value.id && value.type == 6 && value.status){
                    acc[value.id] = value
                }
                return acc
            }, {})
        },
        products(){
            // Usar directamente los productos PLK unificados
            return this.$store.getters['production/getPlkProducts']
        },
        /**
         * Stock dinámico que incluye el stock base + las unidades que se van a cocinar
         * El stock base se genera automáticamente a partir de los productos disponibles
         */
        stock() {
            // Usar directamente el stock PLK unificado
            return this.$store.getters['production/getPlkStock']
        },

        productsCooking() {
            // Usar directamente los productos cocinando unificados
            return this.$store.getters['production/getCookingProducts']
        },
        
        /**
         * Productos cocinando seleccionados
         */
        selectedCookingProducts() {
            return this.$store.getters['production/getSelectedCookingProducts']
        },
        timezone() {
            return this.$store.getters['getTimeZoneName']
        }
    },
    methods: {
        dismissResetNotice() {
            this.$store.commit('production/setResetNotice', false)
        },
        deleteSelected(products) {
            this.$store.dispatch('production/removeSelectedCookingProducts')
            //Haz que se borre el producto de la lista de productos cocinando
            products.forEach(product => {
                // ACTUALIZAR EL STOCK INMEDIATAMENTE cuando se finaliza manualmente
                if (product.reference_id && product.quantity) {
                    // Obtener el nombre del producto desde la lista de productos
                    const productInfo = this.productsList[product.reference_id]
                    if (productInfo) {
                        // Buscar si el producto ya existe en el stock
                        const existingStockItem = this.stock.find(item => item.id === product.reference_id)
                        
                        if (existingStockItem) {
                            // Si existe, incrementar la cantidad usando updatePlkStockItem
                            const units = productInfo.drops ? Object.values(productInfo.drops)[0].units : 1
                            const newQuantity = (existingStockItem.units || 0) + parseInt(product.quantity) * units
                            this.$store.commit('production/updatePlkStockItem', {
                                itemId: product.reference_id,
                                updates: {
                                    units: newQuantity
                                }
                            })
                        }
                    }
                }
                
                this.$store.commit('production/removeCookingProduct', product.id)
                const fryersInUse = this.fryers.filter(fryer => fryer.status === 2)
                if (fryersInUse.length > 0) {
                    this.updateFryerStatus(fryersInUse[fryersInUse.length - 1].id, 1)
                }
            })
        },
        addProduct(product, callback) {
            // Verificar que el producto existe y tiene las propiedades necesarias
            if (!product) {
                log('addProduct: producto es undefined')
                if (callback) callback(false)
                return
            }
            
            // Verificar si hay freidoras disponibles
            const availableFryer = this.getAvailableFryer()
            if (!availableFryer) {
                // No hay freidoras disponibles
                    this.$popup.messageNewDesing({
                        title: this.$t('production.plk.fryers.popup.not-available.title'),
                        
                        message: this.$t('production.plk.fryers.popup.not-available.message'),
                        textSave: this.$t('production.plk.fryers.popup.not-available.button')
                    })
                if (callback) callback(false)
                return
            }
            
            // Mostrar popup para confirmar cantidad
            this.$popup.numericNewDesing({
                title: this.$t('production.plk.fryers.popup.select-product-number.title'),
                message: product.name || this.$t('production.plk.fryers.popup.select-product-number.message'),
                inputVal: product.currentUnits || 0,
                productName: product.name,
                productUrl: product.image,
                productMessage: this.$t('production.plk.pending-to-make.popup.product-message'),
                customClass: 'pls-stock-popup',
                callSave: (self, store) => {
                    const selectedQuantity = self.inputVal
                    self.$popup.close()

                    // Si la cantidad seleccionada es menor a la disponible, dividir el producto
                    if (selectedQuantity < (product.currentUnits || 0)) {
                        this.divideProduct(product, selectedQuantity, availableFryer, callback)
                    } else {
                        // Usar toda la cantidad disponible
                        this.processProductDirectly(product, selectedQuantity, availableFryer, callback)
                    }
                },
                callDelete: () => {
                    this.deleteRecommendation(product)
                }
            })
        },

        deleteRecommendation(product) {
            this.$popup.close()
            const message = this.$t('production.plk.pending-to-make.remove-recommendation-message', { product: product.name })
            const self = this
            this.$popup.messageNewDesing({
                customClass: 'pls-stock-popup',
                title: this.$t('production.plk.pending-to-make.remove-recommendation'),
                textSave: this.$t('production.plk.pending-to-make.remove-recommendation-accept'),
                textCancel: this.$t('production.plk.pending-to-make.remove-recommendation-cancel'),
                message: message,
                callSave: () => {
                    self.$store.dispatch('production/removeRecommendation', { batchId: product.batch_id }).then(function(response) {
                        if(response && response.status) {
                            self.$popup.close()

                            //Actualizar el forecast
                            self.updateForecast()
                        }
                    })
                }
            })
        },
        
        /**
         * Obtiene una freidora disponible (status 1)
         */
        getAvailableFryer() {
            return this.fryers.find(fryer => fryer && fryer.status === 1)
        },
        
        /**
         * Actualiza el status de una freidora
         */
        updateFryerStatus(fryerId, newStatus) {
            // Verificar que fryerId existe antes de actualizar
            if (fryerId === undefined || fryerId === null) {
                log('updateFryerStatus: fryerId es undefined o null')
                return
            }
            
            // Actualizar el status de la freidora directamente
            this.$store.commit('production/updateFryerStatus', {
                fryerId: fryerId,
                status: newStatus
            })
        },
        
        /**
         * Libera una freidora cuando se completa la cocción
         */
        releaseFryer(fryerId) {
            this.updateFryerStatus(fryerId, 1) // Volver a disponible
        },
        

        /**
         * Obtiene información detallada del stock de un producto
         */
        getStockInfo(productId) {
            return this.stock.find(item => item.id === productId)
        },
        /**
         * Calcula los minutos restantes desde ahora hasta una fecha objetivo
         */
        calculateRemainingMinutes(targetDateTime) {
            if (!targetDateTime) return 0
            
            // Parsear la fecha objetivo (formato: "YYYY-MM-DD HH:mm:ss")
            const targetDate = moment(targetDateTime)
            if (!targetDate.isValid()) {
                log('Fecha inválida:', targetDateTime)
                return 0
            }
            
            // Obtener la hora actual
            const now = moment()
            
            // Calcular diferencia en minutos
            const diffMinutes = targetDate.diff(now, 'minutes')
            
            // Retornar 0 si ya pasó el tiempo, o los minutos restantes
            return Math.max(0, diffMinutes)
        },
        load() {
            this.debug = localStorage.getItem('debug_pls') ? localStorage.getItem('debug_pls') == '1' : false
            let self = this

            self.selectCategory(false)

            this.loadFryers()

            // Select today date based on the schedule

            if (!this.userInteraction) {
                this.date = moment().format('YYYY-MM-DD')
            }

            let config = this.$store.getters['login/getConfig']
            let start_hour = 8
            if (config && config.schedule && config.schedule.schedule) {
                let schedule = config.schedule.schedule
                let dayMap = { '1': 'm', '2': 't', '3': 'w', '4': 'r', '5': 'f', '6': 's', '0': 'u' }
                let day = dayMap[moment().format('d').toLowerCase()]
                if (schedule[day] && schedule[day].c && schedule[day].c.s) {
                    start_hour = parseInt(schedule[day].c.s.split(':')[0])
                }
            }

            // Comentado para que siempre use el día actual
            // if (moment().isSame(moment(), 'day') && moment().hour() < start_hour) {
            //     this.date = moment().subtract(1, 'days').format('YYYY-MM-DD')
            // }

            if (this.products.length == 0) {
                this.$overlay.loading()
                this.$store.dispatch('production/loadData').then(() => {
                    self.selectCategory(false)
                    self.$overlay.hide()
                    this.loadForecast()
                })
            } else {
                this.loadForecast()
            }
        },
        loadForecast() {
            let self = this
            if (this.firstLoad) {
                this.$overlay.loading()
                this.$store.dispatch('production/loadForecast', { date: this.date, type: 'pls-stock' }).then(() => {
                    // Cargar todos los datos del forecast en las variables unificadas
                    this.loadCookingProductsFromForecast()
                    this.loadPlkProductsFromForecast()
                    this.loadPlkStockFromForecast()
                    self.$overlay.hide()
                })
            }
        },

        updateForecast(){
            this.$store.dispatch('production/loadForecast', { date: this.date, type: 'pls-stock' }).then(() => {
                // Cargar todos los datos del forecast en las variables unificadas
                this.loadCookingProductsFromForecast()
                this.loadPlkProductsFromForecast()
                this.loadPlkStockFromForecast()
            })
        },
        
        /**
         * Actualización optimista del store (inmediata)
         */
        updateStoreOptimistically(product, selectedQuantity, remainingQuantity, batchId) {
            // Remover el producto procesado de la lista de productos
            this.$store.commit('production/removePlkProduct', product.id)
            
            // Si hay unidades restantes, crear un nuevo producto con las unidades restantes
            if (remainingQuantity > 0) {
                const remainingProduct = {
                    ...product,
                    id: `${product.id}_remaining`,
                    batch_id: batchId + '_remaining',
                    currentUnits: remainingQuantity,
                    // Mantener la misma información de horas pero con las unidades restantes
                    hours: product.hours,
                    slotStartTime: product.slotStartTime,
                    slotEndTime: product.slotEndTime,
                    currentTime: product.currentTime
                }
                
                // Agregar el producto restante
                this.$store.commit('production/addPlkProduct', remainingProduct)
            }
            
            // Forzar recálculo de productos
            this.$forceUpdate()
        },
        
        /**
         * Sincronización con la API en segundo plano
         */
        async syncWithAPI(product, selectedQuantity, remainingQuantity, batchId, originalState, cookingProductId = null) {
            try {
                //Se actualiza el status y el ready_date del batch original -> la peticion devuelve el id del batch
                const editResponse = await this.$store.dispatch('production/editBatch', {
                    batchId: batchId,
                    reference_id: product.originalId,
                    quantity: selectedQuantity,
                    date: moment().format('YYYY-MM-DD HH:mm:ss'),
                    duration: product.cooking_time,
                    business_date: moment().format('YYYY-MM-DD'),
                })
                
                // Verificar si el editBatch falló
                if (editResponse && !editResponse.status) {
                    // Mostrar snackbar de error
                    this.$snackbar.error({
                        message: this.$t('production.plk.error_action.recalculation'),
                        closeable: true,
                        timeout: 5000
                    })
                    
                    // Limpiar productos procesados ANTES de recargar para que vuelvan a aparecer
                    this.$store.commit('production/clearProcessedProductIds')
                    
                    // Recargar los datos actuales del forecast
                    await this.$store.dispatch('production/loadForecast', { date: this.date, type: 'pls-stock' })
                    
                    // Recargar todos los datos del forecast en las variables unificadas
                    this.loadCookingProductsFromForecast()
                    this.loadPlkProductsFromForecast()
                    this.loadPlkStockFromForecast()
                    
                    // Forzar actualización de la vista
                    this.$forceUpdate()
                    
                    return false
                }
                
                // Si el edit fue exitoso, continuar normalmente
                if(editResponse && editResponse.data && editResponse.data.id){
                    //Editar el batch de productos  temporal de la store con el nuevo batch
                    log('-- editCookingBatch',batchId,editResponse.data.id)
                    this.$store.commit('production/editCookingBatch', {
                        temporalBatchId: batchId,
                        originalBatchId: editResponse.data.id,
                    })
                }
                
                // Si hay unidades restantes, crear un nuevo batch (SOLO si el edit fue exitoso)
                if (remainingQuantity > 0) {
                    //Se crea un nuevo producto para quedarse en la store de productos -> se devuelve el id del batch como [id]
                    const addResponse = await this.$store.dispatch('production/addBatch', {
                        reference_id: product.originalId,
                        quantity: remainingQuantity,
                        recommended_date: product.orginalRecommendedDate,
                        business_date: moment().format('YYYY-MM-DD'),
                    })
                    
                    if(addResponse && addResponse.data && addResponse.data.id){
                        //Editar el batch de productos  temporal de la store con el nuevo batch
                        this.$store.commit('production/editBatch', {
                            temporalBatchId: batchId + '_remaining',
                            originalBatchId: addResponse.data.id,
                        })
                    }
                }
                
                // Limpiar productos procesados ya que ahora están en el forecast real
                this.$store.commit('production/clearProcessedProductIds')
                
                return true
                
            } catch (error) {
                log('Error sincronizando con API:', error)
                return false
            }
        },
        
        /**
         * Revertir cambios optimistas en caso de error
         */
        revertOptimisticChanges(originalState) {
            try {
                // Restaurar el forecast original
                if (originalState.forecast) {
                    this.$store.commit('production/setForecast', originalState.forecast)
                }
                
                // Recargar todos los datos del forecast
                this.loadCookingProductsFromForecast()
                this.loadPlkProductsFromForecast()
                this.loadPlkStockFromForecast()
                
                // Limpiar productos procesados
                this.$store.commit('production/clearProcessedProductIds')
                
                // No es necesario limpiar nada ya que las freidoras se actualizan directamente
                
                // Forzar recálculo
                this.$forceUpdate()
                
                // Mostrar notificación de error
                this.$snackbar.error({
                    message: 'Error al procesar el producto. Los cambios se han revertido.',
                    closeable: true,
                    timeout: 5000
                })
                
            } catch (error) {
                log('Error revirtiendo cambios:', error)
            }
        },
        loadFryers(){
            this.$store.dispatch('production/loadFryers')
        },
        selectCategory(category) {
            var self = this
            self.$overlay.loading()
            this.$store.commit('production/selectCategory', category)
            self.$overlay.hide()
        },
        selectMermaProduct(product) {
            // Mostrar popup para confirmar cantidad
            this.$popup.numericNewDesing({
                title: this.$t('production.plk.fryers.popup.waste.title'),
                message: product.name,
                inputVal: product.units,
                numericNewDesing: {
                    max: product.units,
                },
                callSave: (self, store) => {
                    const selectedQuantity = self.inputVal
                    self.$popup.close()


                    // Guardar estado original para poder revertir en caso de error
                    const originalState = {
                        product: { ...product },
                        forecast: JSON.parse(JSON.stringify(this.forecast))
                    }

                    try {
                        // Mostrar notificación de éxito
                        this.$snackbar.info({
                            message: this.$t('production.plk.fryers.snackbar.stock.message'),
                            customClass: 'new-desing',
                            closeable: true,
                            timeout: 3000
                        })
                        
                        // Llamada a la API en segundo plano
                        this.syncMermaWithAPI(product, selectedQuantity, originalState)
                        
                    } catch (error) {
                        log('Error en selectMermaProduct:', error)
                        // Revertir cambios en caso de error
                        this.revertMermaChanges(originalState, product.id)
                    }
                }
            })
        },
        selectDate(date) {
            /* if (this.date != date) {
                this.firstLoad = true
                this.date = moment(date).format('YYYY-MM-DD')
                this.loadForecast()
                this.userInteraction = true
            } */
        },
        async refreshPage() {
            const hasConnection = fnCheckConnection()
            if (hasConnection) {
                window.location.reload()
            }
        },
        toggleSidebar() {
            this.sidebarExpanded = !this.sidebarExpanded
            localStorage.setItem('sidebarExpanded', this.sidebarExpanded)
        },
        onCookingCompleted(product) {
            // Verificar que el producto existe y tiene las propiedades necesarias
            if (!product) {
                log('onCookingCompleted: producto es undefined')
                return
            }
            
            // Prevenir múltiples ejecuciones usando un flag
            if (product._completed) {
                log('Producto ya fue procesado, ignorando:', product.name)
                return
            }
            
            // Marcar como completado para evitar ejecuciones múltiples
            product._completed = true

            // Liberar la última freidora en uso (status 2)
            const fryersInUse = this.fryers.filter(fryer => fryer.status === 2)
            if (fryersInUse.length > 0) {
                this.updateFryerStatus(fryersInUse[fryersInUse.length - 1].id, 1)
            }

            // ACTUALIZAR EL STOCK INMEDIATAMENTE cuando se completa la cocción
            if (product.reference_id && product.quantity) {
                // Obtener el nombre del producto desde la lista de productos
                const productInfo = this.productsList[product.reference_id]
                if (productInfo) {
                    // Buscar si el producto ya existe en el stock
                    const existingStockItem = this.stock.find(item => item.id === product.reference_id)
                    
                    if (existingStockItem) {
                        // Si existe, incrementar la cantidad usando updatePlkStockItem
                        //Si tiene drops, multiplicar la cantidad por el numero de drops
                        const units = productInfo.drops ? Object.values(productInfo.drops)[0].units : 1
                        const newQuantity = (existingStockItem.units || 0) + parseInt(product.quantity) * units
                        this.$store.commit('production/updatePlkStockItem', {
                            itemId: product.reference_id,
                            updates: {
                                units: newQuantity
                            }
                        })
                    }
                }
            }
            
            // Remover el producto completado de la lista de cocinando
            this.$store.commit('production/removeCookingProduct', product.id)
        },
        
        /**
         * Sincronización de merma con la API en segundo plano
         */
        async syncMermaWithAPI(product, selectedQuantity, originalState) {
            try {
                // Llamar a la API para registrar la merma
                await this.$store.dispatch('production/addBatch', {
                    reference_id: product.id,
                    quantity: -selectedQuantity,
                    date: moment().format('YYYY-MM-DD HH:mm:ss'),
                    duration: product.cooking_time || 0,
                    business_date: moment().format('YYYY-MM-DD'),
                    data: JSON.stringify({
                        user_merma: 1
                    }),
                    status: 1,
                })
                
                // Actualizar el forecast en segundo plano
                this.loadForecast()
                
            } catch (error) {
                log('Error sincronizando merma con API:', error)
                throw error // Re-lanzar para que se maneje en el catch del método padre
            }
        },
        
        /**
         * Carga los productos cocinando del forecast en la variable unificada
         */
        loadCookingProductsFromForecast() {
            const self = this
            const cookingProducts = []
            
            if(this.forecast && this.forecast.products && this.forecast.products.cooking && Object.keys(self.productsList).length > 0){
                const productsList = this.forecast.products.cooking || {}
                if(productsList && productsList.length > 0){
                    productsList.forEach((product, index) => {
                        // Verificar que el producto existe y tiene las propiedades necesarias
                        if(product && product.reference_id && self.productsList[product.reference_id]){
                            cookingProducts.push({
                                ...product,
                                id: product.id || `forecast-${product.reference_id}-${index}`, // Asegurar ID único
                                name: self.productsList[product.reference_id].name,
                            })
                        }
                    })
                }
            }
            
            // Cargar en la variable unificada
            this.$store.commit('production/setCookingProducts', cookingProducts)
            
            // Asignar freidoras a los productos
            this.assignFryersToForecastProducts()
        },
        
        /**
         * Carga los productos PLK del forecast en la variable unificada
         * Los datos (quantity, batch_id) vienen de la API, el tiempo se calcula en el frontend
         */
        loadPlkProductsFromForecast() {
            log('loadPlkProductsFromForecast')
            const self = this
            const products = []
            
            if(this.forecast && this.forecast.products && this.forecast.products.pls && Object.keys(self.productsList).length > 0){
                const productsList = this.forecast.products.pls || {}
                
                // Obtener IDs de productos procesados para excluirlos
                const processedProductIds = this.$store.getters['production/getProcessedProductIds']
                
                Object.entries(productsList).forEach(([key, hours]) => {
                    const product = self.productsList[key]
                    if(product && hours){
                        // Procesar cada hora/fecha del producto
                        Object.entries(hours).forEach(([timeKey, hourData]) => {
                            // Extraer los datos que vienen de la API
                            const units = hourData && typeof hourData === 'object' && 'quantity' in hourData ? (hourData.quantity || 0) : (hourData || 0)
                            const batchId = hourData && typeof hourData === 'object' && 'batch_id' in hourData ? (hourData.batch_id || false) : false
                            
                            // Calcular el tiempo restante en minutos (esto se hace en el frontend)
                            const remainingMinutes = this.calculateRemainingMinutes(timeKey)
                            
                            const productId = `${product.id}_${timeKey}`
                            
                            // Excluir productos procesados
                            if (processedProductIds.includes(productId)) {
                                return
                            }
                            
                            const product_data = {
                                ...product,
                                id: productId, // ID único
                                batch_id: batchId,
                                originalId: product.id, // ID original del producto
                                time: product.cooking_time,
                                hours: { [timeKey]: hourData }, // Datos originales de la API
                                orginalRecommendedDate: timeKey,
                                currentTime: remainingMinutes, // Minutos restantes calculados en el frontend
                                currentUnits: Math.ceil(units),
                                unitName: Object.keys(product.drops).length > 0 ? 'drops' : 'uds'
                            }
                            products.push(product_data)
                        })
                    }
                })
            }
            
            // Cargar en la variable unificada
            this.$store.commit('production/setPlkProducts', products)
        },
        
        /**
         * Carga el stock PLK del forecast en la variable unificada
         */
        loadPlkStockFromForecast() {
            const self = this
            const stock = []
            
            if(this.forecast && this.forecast.products && this.forecast.products.stored && Object.keys(self.productsList).length > 0){
                const productsList = this.forecast.products.stored || {}
                
                Object.entries(productsList).forEach(([key, value]) => {
                    const product = self.productsList[key]
                    if(product){
                        stock.push({
                            id: key,
                            name: product.name,
                            units: value,
                            originalUnits: value,
                            unitName: Object.keys(product.drops).length > 0 ? 'drops' : 'uds'
                        })
                    }
                })
            }
            
            // Cargar en la variable unificada
            this.$store.commit('production/setPlkStock', stock)
        },
        
        /**
         * Asigna freidoras a los productos del forecast que no tienen una asignada
         */
        assignFryersToForecastProducts() {
            //Primero poner todas las freidoras que esten en status 2 en 1
            const fryersInUse = this.fryers.filter(fryer => fryer.status === 2 || fryer.status === 1)
            fryersInUse.forEach(fryer => {
                this.updateFryerStatus(fryer.id, 1)
            })

            const cookingProducts = this.$store.getters['production/getCookingProducts']
            if(cookingProducts && cookingProducts.length > 0) {
                const fryersToUse = cookingProducts.length
                const fryersAvailable = this.fryers.filter(fryer => fryer && fryer.status === 1)
                for(let i = 0; i < fryersToUse && i < fryersAvailable.length; i++) {
                    if(fryersAvailable[i] && fryersAvailable[i].id) {
                        this.updateFryerStatus(fryersAvailable[i].id, 2)
                    }
                }
            }
        },
        
        /**
         * Revertir cambios de merma en caso de error
         */
        revertMermaChanges(originalState, productId) {
            try {
                // Restaurar el forecast original
                if (originalState.forecast) {
                    this.$store.commit('production/setForecast', originalState.forecast)
                }
                
                // Forzar recálculo
                this.$forceUpdate()
                
                // Mostrar notificación de error
                this.$snackbar.error({
                    message: 'Error al registrar el desperdicio. Los cambios se han revertido.',
                    closeable: true,
                    timeout: 5000
                })
                
            } catch (error) {
                log('Error revirtiendo cambios de merma:', error)
            }
        },

        /**
         * Divide el producto cuando se selecciona una cantidad menor
         */
        async divideProduct(product, selectedQuantity, availableFryer, callback) {
            // Verificar que todos los parámetros existen
            if (!product || !availableFryer) {
                log('divideProduct: producto o freidora es undefined')
                if (callback) callback(false)
                return
            }
            
            const remainingQuantity = (product.currentUnits || 0) - selectedQuantity
            
            // Obtener el batchId del producto (ya viene directamente de la API)
            const batchId = product.batch_id
            
            // Guardar estado original para poder revertir en caso de error
            const originalState = {
                product: { ...product },
                forecast: JSON.parse(JSON.stringify(this.forecast))
            }
            
            try {
                // 1. Actualización optimista en el store (inmediata)
                this.updateStoreOptimistically(product, selectedQuantity, remainingQuantity, batchId)
                
                // Marcar el producto como procesado para quitarlo de la lista de pendientes
                this.$store.commit('production/addProcessedProductId', product.id)
                
                // 2. Agregar producto a la lista de cocinando inmediatamente
                const now = moment()
                const readyDate = now.add(product.cooking_time, 'minutes')
                
                const cookingProduct = {
                    id: `${product.id}_cooking_${Date.now()}`, // ID único
                    batch_id: batchId, // Agregar el batch ID para consistencia
                    reference_id: product.originalId,
                    name: product.name,
                    quantity: selectedQuantity,
                    fryerId: availableFryer.id,
                    addedAt: now.format('YYYY-MM-DD HH:mm:ss'),
                    startTime: now.format('YYYY-MM-DD HH:mm:ss'),
                    created_date: now.format('YYYY-MM-DD HH:mm:ss'),
                    ready_date: readyDate.format('YYYY-MM-DD HH:mm:ss'),
                    estimatedEndTime: readyDate.format('YYYY-MM-DD HH:mm:ss'),
                    duration: product.cooking_time,
                    time: product.cooking_time,
                    status: 'cooking'
                }
                
                this.$store.commit('production/addCookingProduct', cookingProduct)
                
                // 3. Cambiar el status de la freidora inmediatamente
                this.updateFryerStatus(availableFryer.id, 2)
                
                // 4. Llamar callback inmediatamente para actualizar UI
                if (callback) callback(true)
                
                // 5. Peticiones a la API en segundo plano
                const syncResult = await this.syncWithAPI(product, selectedQuantity, remainingQuantity, batchId, originalState, cookingProduct.id)
                
                // Si syncWithAPI retornó false (error con status false), ya se manejó el error allí
                // Solo necesitamos remover el producto de cocinando y liberar la freidora
                if (!syncResult) {
                    this.$store.commit('production/removeCookingProduct', cookingProduct.id)
                    this.updateFryerStatus(availableFryer.id, 1)
                }
                
            } catch (error) {
                log('Error en divideProduct:', error)
                // Intentar revertir cambios de forma segura
                try {
                    this.revertOptimisticChanges(originalState)
                    this.updateFryerStatus(availableFryer.id, 1)
                } catch (revertError) {
                }
                
                if (callback) callback(false)
            }
        },
        
        /**
         * Procesa el producto directamente para cocinarlo
         */
        async processProductDirectly(product, quantity, availableFryer, callback) {
            // Verificar que todos los parámetros existen
            if (!product || !availableFryer) {
                log('processProductDirectly: producto o freidora es undefined')
                if (callback) callback(false)
                return
            }
            
            // Obtener el batchId del producto (ya viene directamente de la API)
            const batchId = product.batch_id

            // Guardar estado original para poder revertir en caso de error
            const originalState = {
                product: { ...product },
                forecast: JSON.parse(JSON.stringify(this.forecast))
            }
            
            try {
                // 1. Actualización optimista en el store (inmediata)
                this.updateStoreOptimistically(product, quantity, 0, batchId)
                
                // Marcar el producto como procesado para quitarlo de la lista de pendientes
                this.$store.commit('production/addProcessedProductId', product.id)
                
                // 2. Agregar producto a la lista de cocinando inmediatamente
                const now = moment()
                const readyDate = now.add(product.cooking_time, 'minutes')
                
                const cookingProduct = {
                    id: `${product.id}_cooking_${Date.now()}`, // ID único
                    batch_id: batchId, // Agregar el batch ID para consistencia
                    reference_id: product.originalId,
                    name: product.name,
                    quantity: quantity,
                    fryerId: availableFryer.id,
                    addedAt: now.format('YYYY-MM-DD HH:mm:ss'),
                    startTime: now.format('YYYY-MM-DD HH:mm:ss'),
                    created_date: now.format('YYYY-MM-DD HH:mm:ss'),
                    ready_date: readyDate.format('YYYY-MM-DD HH:mm:ss'),
                    estimatedEndTime: readyDate.format('YYYY-MM-DD HH:mm:ss'),
                    duration: product.cooking_time,
                    time: product.cooking_time,
                    status: 'cooking'
                }
                
                this.$store.commit('production/addCookingProduct', cookingProduct)
                
                // 3. Cambiar el status de la freidora inmediatamente
                this.updateFryerStatus(availableFryer.id, 2)
                
                // 4. Llamar callback inmediatamente para actualizar UI
                if (callback) callback(true)
                
                // 5. Petición a la API en segundo plano
                const syncResult = await this.syncWithAPI(product, quantity, 0, batchId, originalState, cookingProduct.id)
                
                // Si syncWithAPI retornó false (error con status false), ya se manejó el error allí
                // Solo necesitamos remover el producto de cocinando y liberar la freidora
                if (!syncResult) {
                    this.$store.commit('production/removeCookingProduct', cookingProduct.id)
                    this.updateFryerStatus(availableFryer.id, 1)
                }
                
            } catch (error) {
                log('Error en processProductDirectly:', error)
                // Intentar revertir cambios de forma segura
                try {
                    this.revertOptimisticChanges(originalState)
                    this.updateFryerStatus(availableFryer.id, 1)
                } catch (revertError) {
                }
                
                if (callback) callback(false)
            }
        },
        initFryer() {
            this.$store.dispatch('production/initFryer').then(response => {
            })
        }
    },
    created() {
        this.initFryer()
        this.load()
        
        // Timer para actualizar forecast cada minuto real del sistema (MÁS IMPORTANTE)
        this.forecastUpdateInterval = setInterval(() => {
            // Solo actualizar si estamos en el primer segundo del minuto
            const now = new Date()
            if (now.getSeconds() === 0) { //Buscar el segundo 0 por el tiempo que tarda la peticion cambiar si es necesario
                this.updateForecast()
                /* this.$snackbar.info({
                    message: "Actualizando forecast",
                    closeable: true,
                    timeout: 1000
                }) */
                // Forzar recálculo de productos para actualizar los minutos
                this.$forceUpdate()
            }
        }, 1000) // Verificar cada segundo, pero solo ejecutar en el minuto 0
    },
    beforeDestroy() {
        if (this.forecastUpdateInterval) {
            clearInterval(this.forecastUpdateInterval)
        }
    },
    mounted() { },
    watch: {
        currentTime: {
            handler() {
                // Forzar recálculo de productos cuando cambia el tiempo
                this.$forceUpdate()
            }
        },
        products: {
            handler() {
                //this.forceProductsRecalculation()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
/* Azul del icono informativo del aviso de reseteo. */
$reset-notice-icon: #3982e5;

#production {
    position: relative;
    height: 100%;
    width: 100%;
    grid-template-columns: 300px auto;
    grid-template-rows: 1fr;
    grid-template-areas: "sidebar board";
    display: grid;
    x-justify-content: space-around;
    x-align-items: stretch;
    width: 100%;

    &.collapsed {
        grid-template-columns: 57px auto;
    }

    &.configuration {
        grid-template-areas: "board board";
    }

    .reset-notice {
        position: absolute;
        left: 50%;
        bottom: 16px;
        z-index: 20;
        @include display-flex();
        @include align-items(center);
        transform: translateX(-50%);
        pointer-events: none;

        .reset-notice-andy {
            @include background($image: img('alex_carita_02_right.svg'), $size: contain);
            flex-shrink: 0;
            width: 48px;
            height: 48px;
            margin-right: 4px;
        }

        .reset-notice-body {
            @include display-flex();
            @include align-items(center);
            gap: 8px;
            padding: 12px 16px;
            border-radius: 8px;
            background-color: $color-secondary-100;
            pointer-events: auto;

            i {
                color: $reset-notice-icon;
            }

            span {
                font-family: $text;
                @include font-size(16px);
                color: $color-neutral-800;
                white-space: nowrap;
            }
        }

        .reset-notice-close {
            @include display-flex();
            @include align-items(center);
            @include justify-content(center);
            width: 24px;
            height: 24px;
            margin-left: 8px;
            padding: 0;
            border: none;
            background: transparent;
            cursor: pointer;

            i {
                color: $color-neutral-800;
            }
        }
    }

    #sidebar {
        grid-area: sidebar;
        height: 100%;
        background-color: #fff;
        width: 100%;

        &.collapsed {
            width: 57px;
            background-color: transparent;
        }
    }

    #board {
        grid-area: board;
        height: 100%;
        max-height:100%;
        overflow: hidden;
        width: 100%;

        .main-content {
            height: 100%;
        }
    }

    /* PLS SIZES MONITORS*/
    &.landscape {
        grid-template-columns: 250px auto;

        &.collapsed {
            grid-template-columns: 45px auto;
        }
    }
}
</style>
